import { descriptiveExamManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher];

const descriptiveExamManagementRouteMetadata: IRouteMetadataObj<
  typeof descriptiveExamManagementRoutesObj
> = {
  list: {
    title: "descriptiveExamManagement.index.title",
    description: "descriptiveExamManagement.index.description",
    lazy: () => import("@/pages/descriptiveExamManagement/table/page"),
    mode: "index",
    type: "main",
    icon: "FileChartLine",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "descriptiveExamManagement.create.title",
    description: "descriptiveExamManagement.create.description",
    lazy: () => import("@/pages/descriptiveExamManagement/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "descriptiveExamManagement.edit.title",
    description: "descriptiveExamManagement.edit.description",
    lazy: () => import("@/pages/descriptiveExamManagement/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "descriptiveExamManagement.view.title",
    description: "descriptiveExamManagement.view.description",
    lazy: () => import("@/pages/descriptiveExamManagement/view/page"),
    mode: "edit",
    type: "inner",
    icon: "GraduationCapLine",
    breadcrumbs: [],
    permission,
  },
};

export const descriptiveExamManagementRoutes = createRoute<
  typeof descriptiveExamManagementRoutesObj
>(descriptiveExamManagementRoutesObj, descriptiveExamManagementRouteMetadata);
